
import { Component, Vue, Prop } from 'vue-property-decorator';
import SColumn from './SColumn.vue';
import { CreateElement, VNodeData } from 'vue';
import { escape } from 'lodash';

@Component
export default class SColumnCell<Item> extends Vue {
  @Prop(Object) private item!: Item;
  @Prop(Object) private column!: SColumn<Item>;

  private render(createElement: CreateElement) {
    const options: VNodeData = {
      class: this.column.class,
      style: this.column.style,
    };
    if (this.column.getTitle(this.item).length > 0) {
      options['directives'] = [
        {
          name: 'tooltip',
          value: {
            content: `<p>${escape(this.column.getTitle(this.item))}</p>`,
            trigger: 'hover',
          },
          modifiers: { bottom: true },
        },
      ];
    }

    return createElement(
      'td',
      options,
      this.column.template({ item: this.item }),
    );
  }
}
